import { ProductRatesForm } from 'store/modules/override-rates/productRatesForm';
import { computed, makeObservable, observable } from 'mobx';
import { Rate } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { OverrideProduct } from './pageStore';

interface Props {
  quotedProduct: OverrideProduct;
}

export class QuotedProductRatesForm extends ProductRatesForm {
  private readonly _rates: Rate[];

  public get rates(): Rate[] {
    return this._rates;
  }

  public resetToInitialRates(): void {
    Object.keys(this._formController.fields).forEach((key) => {
      this._formController.fields[key].value = Number(
        this._rates.find((rate) => rate.key === key)?.value || '',
      ).toFixed(2);
    });
  }

  constructor(props: Props) {
    super({
      rates: props.quotedProduct.productSummary.rates,
      portfolioId: props.quotedProduct.portfolioId,
      productId: props.quotedProduct.productId,
      bcIndex: props.quotedProduct.bcIndex,
      productName: props.quotedProduct.productName,
    });
    this._rates = props.quotedProduct.productSummary.rates;

    makeObservable<QuotedProductRatesForm, '_rates'>(this, {
      _rates: observable,
      rates: computed,
    });
  }
}
